/*  MUI  */
import { Grid } from '@mui/material';

/*  Shared  */
import {
    DataAPIVisualsPieChart,
    DataAPIVisualsTotal
} from 'application/Shared/Components/DataAPIVisualsCard';
import { useManagedTableV2Context } from 'application/Shared/Components/Table';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

export const AdminUsersCharts = () => {
    const { t } = useTranslation();
    const { table } = useManagedTableV2Context();
    // We are using filtred rows from the table to get the data
    const data = table.getFilteredRowModel().rows.map((row) => row.original);

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={6} lg={4}>
                <DataAPIVisualsTotal
                    title={t('Users.userCount')}
                    card
                    data={data}
                />
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
                <DataAPIVisualsPieChart
                    accessorKey="createdBy"
                    card
                    data={data}
                    nameMap={{
                        'Browser Log-in': t('Common.browser'),
                        'Device Log-in': t('Common.device'),
                        'Domain Auth': t('Common.domainAuth'),
                        Google: t('Common.google'),
                        'Microsoft Entra ID': t('Common.microsoftEntraID')
                    }}
                    title={t('Common.created_by')}
                />
            </Grid>
            <Grid item xs={12} sm={6} lg={4}>
                <DataAPIVisualsPieChart
                    accessorKey="domainManaged"
                    card
                    data={data}
                    nameMap={{
                        false: t('Common.unmanaged'),
                        true: t('Common.managed')
                    }}
                    title={t('Common.domain_managed')}
                />
            </Grid>
        </Grid>
    );
};
